import { ReferenceManyField, TextField } from 'react-admin';
import { TurnReferencesEnum, TurnTargetsEnum } from '@/types/turn-enums';
import { MainDatagridStyled } from '@/styles/overrides';
import AccordionWrapper from '../AccordionWrapper';
import LicenseField from './LicenseField';

const Licenses = () => {
  return (
    <AccordionWrapper title="Licenses">
      <ReferenceManyField
        label={false}
        reference={TurnReferencesEnum.Candidates}
        target={TurnTargetsEnum.WorkerMvrLicense}
      >
        <MainDatagridStyled bulkActionButtons={false} rowClick={false}>
          <TextField source="id" />
          <LicenseField label="License Number" />
        </MainDatagridStyled>
      </ReferenceManyField>
    </AccordionWrapper>
  );
};

export default Licenses;
